import axios, { AxiosError } from "axios";

// http handling decorators
export function LogHttpError(msg: number[]) {
  return function (
    target: Object,
    key: string | symbol,
    descriptor: PropertyDescriptor
  ) {
    const original = descriptor.value;
    descriptor.value = async function (...args: any[]) {

      // run and store the result
      try {
        return await original.apply(this, args);
      } catch (error: any) {
        if (axios.isAxiosError(error)) {
          const e = error as AxiosError
          if (msg.includes(e.response && e.response.status || 0)) {
            console.log(`HTTP ERROR ${e.response && e.response.status || 0} ${e.config ? 'TO ' + e.config.url : ''} LOG: ${key.toString()}`)
            e.config && console.log(JSON.stringify(e.config.headers))
          }
          // if (e.response) {
          //   return e.response;
          // }
        }
        return error
      }
    };

    return descriptor;
  };
}